export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "sort_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sort by"])},
        "sort": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sort"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])},
        "relevance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relevance"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
        "ascending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ascending"])},
        "descending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["descending"])},
        "last_modified": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last modified"])},
        "filter_toggle_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detailed search"])}
      },
      "de": {
        "sort_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sortieren nach"])},
        "sort": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sortieren"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Titel"])},
        "relevance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relevanz"])},
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datum"])},
        "ascending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aufsteigend"])},
        "descending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["absteigend"])},
        "last_modified": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zuletzt geändert"])},
        "filter_toggle_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detailsuche"])}
      }
    }
  })
}
